module.exports = __webpack_public_path__ + "img/dai4.56bd0687.png";